import { RootState } from "@/store";
import { employeeFAQs, employeeHelpConfig } from "@/utils/helpPortalConfig";
import {
  ContactsSection,
  FAQSection,
  HelpPortalConfig,
  HelpPortalLayout,
  IntercomWrapper,
  TabNavigation,
} from "@WealthierAI/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useConfig } from "@/config/ConfigContext";

const HelpPortal: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state: RootState) => state.user);
  const { currentStep } = useSelector((state: RootState) => state.wizard);
  const appConfig = useConfig();

  const config: HelpPortalConfig = {
    ...employeeHelpConfig,
    onBackClick: (navigate, location) => {
      employeeHelpConfig.onBackClick?.(navigate, location, dispatch);
    },
  };

  const handleGetHelpClick = () => {
    if (location.pathname === "/help") {
      return;
    }

    navigate("/help", {
      state: {
        from: location.pathname + location.search,
        wizardStep: currentStep,
      },
    });
  };

  return (
    <IntercomWrapper
      appType="employee"
      user={{
        id: user.id,
        email: user.emailAddress,
        firstName: user.firstname,
        lastName: user.lastname,
      }}
      appId={appConfig.VITE_INTERCOM_APP_ID}
      autoOpen={true}
      welcomeDelay={60000}
    >
      <HelpPortalLayout
        config={config}
        navigate={navigate}
        location={location}
        dispatch={dispatch}
        onGetHelpClick={handleGetHelpClick}
      >
        <TabNavigation>
          <FAQSection faqData={employeeFAQs} />
          <ContactsSection />
        </TabNavigation>
      </HelpPortalLayout>
    </IntercomWrapper>
  );
};

export default HelpPortal;
